<template>
  <poppins-popup :value="value" :popupHeader="popupHeader" @close="$emit('close')">
    <div class="flex flex-col gap-16">
      <p v-for="(line, index) in popupBody" :key="`line-` + index" class="text-body">{{ line }}</p>
      <poppins-button
        v-for="(button, index) in popupButtons"
        :key="`button-` + index"
        :value="button.value"
        :variant="button.variant"
        class="w-full"
        size="medium"
        @click="button.clickHandler"
      />
    </div>
  </poppins-popup>
</template>

<script lang="ts">
import PoppinsPopup from '@/components/popup/Popup.vue';
import PoppinsButton from '@/components/button/Button.vue';

const PopupTypes = {
  CONFIRM_HIDE: 'CONFIRM_HIDE',
  PREVIEW_UNHIDE: 'PREVIEW_UNHIDE',
  PREVIEW_CONTACT: 'PREVIEW_CONTACT',
  PREVIEW_REVIEW: 'PREVIEW_REVIEW',
  DEFAULT: '',
};

export default {
  name: 'ProviderProfileEditModePopup',
  components: {
    PoppinsPopup,
    PoppinsButton,
  },
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    variant: {
      type: String,
      default: PopupTypes.DEFAULT,
    },
    paramData: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    careTypeDisplay(): string {
      return this.paramData.careType.replace('_', ' ');
    },
    popupHeader(): string {
      switch (this.variant) {
        case PopupTypes.CONFIRM_HIDE:
          return `Hide ${this.careTypeDisplay} profile?`;
        case PopupTypes.PREVIEW_UNHIDE:
          return 'This profile is currently hidden';
        case PopupTypes.PREVIEW_CONTACT:
          return 'This is a preview of your profile';
        case PopupTypes.PREVIEW_REVIEW:
          return 'This is a preview of your profile';
        default:
          return '';
      }
    },
    popupBody(): string[] {
      switch (this.variant) {
        case PopupTypes.CONFIRM_HIDE:
          return [
            'When you hide a profile families will no longer be able to see it.',
            'Your information will stay saved on this page. If you choose to unhide the profile later, everything will still be here, ready to go.',
            `Do you want to hide your ${this.careTypeDisplay} profile from parents?`,
          ];
        case PopupTypes.PREVIEW_UNHIDE:
          return [
            'Hidden profiles cannot be viewed in preview mode.',
            `Do you want to unhide your ${this.careTypeDisplay} profile?`,
          ];
        case PopupTypes.PREVIEW_CONTACT:
          return [
            "People seeking care will see this button to message you or send job details. Since you're previewing your own profile, it's just for display.",
          ];
        case PopupTypes.PREVIEW_REVIEW:
          return [
            "Families who've worked with you will see this button to leave a review. Since you're previewing your own profile, it's just for display.",
          ];
        default:
          return [];
      }
    },
    popupButtons(): any[] {
      switch (this.variant) {
        case PopupTypes.CONFIRM_HIDE:
          return [
            { value: 'Do not hide', variant: 'primary', clickHandler: () => this.$emit('close') },
            { value: 'Yes, hide this profile', variant: 'outlined', clickHandler: () => this.$emit('toggle-profile-visibility') },
          ];
        case PopupTypes.PREVIEW_UNHIDE:
          return [
            { value: 'Unhide & Preview', variant: 'primary', clickHandler: () => this.$emit('unhide-and-preview') },
            { value: 'Cancel', variant: 'outlined', clickHandler: () => this.$emit('close') },
          ];
        case PopupTypes.PREVIEW_CONTACT:
          return [{ value: 'Got it', variant: 'primary', clickHandler: () => this.$emit('close') }];
        case PopupTypes.PREVIEW_REVIEW:
          return [{ value: 'Got it', variant: 'primary', clickHandler: () => this.$emit('close') }];
        default:
          return [];
      }
    },
  },
};
</script>
